import React from "react";
import { TimelineMax, Power1 } from "gsap/all";
import styled from 'styled-components';
import axios from 'axios';

import ProjectItem from "../components/shared/ProjectItem";
import Footer from "../components/shared/Footer";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      projects: []
    }

    this.content = null;
    this.timeline = new TimelineMax({ paused: true });
  }

  componentDidMount() {
    axios
      .get(`https://www.paralele.me/api/projects/index.php?lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        this.setState({ projects: data })
      })

    this.timeline
      .from(this.content, 1.2, {
        autoAlpha: 0,
        delay: 0.3,
        y: 30,
        ease: Power1.ease
      });

    this.timeline.play();
  }

  render() {
    return (
      <>
        <ProjectListing className="container" ref={content => (this.content = content)}>
          {this.state.projects.map((project, i) => <ProjectItem project={project} title={`Card${i}`} key={i} itemId={i} delay={0.1} />)}
        </ProjectListing>
        <Footer />
      </>
    );
  }
}

const ProjectListing = styled.div`
  display: flex;
  flex-wrap: wrap;

  .Tilt {
    width: 100%;
    margin: 1%;

    @media(min-width: 992px) {
      width: 31%
    }
  }
`

export default Home;
